export const canadaProvinceSelectBoxOptions = [
  { key: 'AB', label: 'AB', value: 'AB' },
  { key: 'BC', label: 'BC', value: 'BC' },
  { key: 'MB', label: 'MB', value: 'MB' },
  { key: 'NB', label: 'NB', value: 'NB' },
  { key: 'NL', label: 'NL', value: 'NL' },
  { key: 'NS', label: 'NS', value: 'NS' },
  { key: 'NT', label: 'NT', value: 'NT' },
  { key: 'NU', label: 'NU', value: 'NU' },
  { key: 'ON', label: 'ON', value: 'ON' },
  { key: 'PE', label: 'PE', value: 'PE' },
  { key: 'QC', label: 'QC', value: 'QC' },
  { key: 'SK', label: 'SK', value: 'SK' },
  { key: 'YT', label: 'YT', value: 'YT' },
];
